import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import SongCard from '../components/SongCard';

const SongDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [song, setSong] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        let cancelled = false;
        (async () => {
            if (!id) {
                setError('Song not found');
                setLoading(false);
                return;
            }
            try {
                const snap = await getDoc(doc(db, 'songs', id));
                if (cancelled) return;
                if (!snap.exists()) {
                    setError('Song not found');
                    setSong(null);
                } else {
                    setSong({ id: snap.id, ...snap.data() });
                    setError('');
                }
            } catch (err) {
                console.error('Failed to load song:', err);
                if (!cancelled) {
                    setError('Unable to load this song');
                    setSong(null);
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => { cancelled = true; };
    }, [id]);

    return (
        <div className="min-h-screen w-full bg-[#0e0e0e] text-white">
            <div className="mx-auto max-w-lg px-4 pt-4 pb-10">
                <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="mb-4 rounded-full bg-white/10 px-3 py-1 text-sm hover:bg-white/20 transition"
                >
                    Back
                </button>

                {loading && (
                    <div className="py-16 text-center text-white/60">Loading song...</div>
                )}

                {!loading && error && (
                    <div className="py-16 text-center text-white/60">{error}</div>
                )}

                {!loading && song && (
                    <SongCard song={song} showTipButton />
                )}
            </div>
        </div>
    );
};

export default SongDetail;
